type Listener = (jobStatus: any) => void;

class JobStatusEventEmitter {
  private listeners: Listener[] = [];

  subscribe(listener: Listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  emit(jobStatus: any) {
    this.listeners.forEach((listener) => listener(jobStatus));
  }
}

const jobStatusEventEmitter = new JobStatusEventEmitter();
export default jobStatusEventEmitter;
